import Vue from 'vue';
import VueJSDatepicker from 'vuejs-datepicker';
import { DatePicker as QDatePicker } from '@qoala/ui/client';

Vue.component('q-date-picker', QDatePicker);
Vue.component('datepicker', VueJSDatepicker);
